import React from "react"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { userInfo, userRole } from "utils"
import ProductList from "./backOffice/ProductList"
import ProductListPageCl from "./clientOffice/ProductListPageCl"

const ProductContainer = props => {
  const { CUSTOMER, CUSTOMER_PURCHASER } = userRole
  const { role } = userInfo()

  useBread({ to: props.match.url, name: "產品維護" }, true)

  if (!role) {
    return <div>404</div>
  }

  if (role === CUSTOMER || role === CUSTOMER_PURCHASER) {
    return <ProductListPageCl />
  }

  return <ProductList />
}

export default withBreadcrumb(ProductContainer)
